import { FaarmLogo } from 'app/agriculture/FarmMain/TopBar/components/FaarmLogo/FaarmLogo';
import { useContext } from 'react';
import { FarmContext } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';
import './AppLogoSection.scss';
import { Button } from 'app/agriculture/components/Button/Button';
import { useNavigate } from 'react-router-dom';

export function AppLogoSection() {
    const { farm } = useContext(FarmContext);
    const navigate = useNavigate();

    return (
        <div className="AppLogoSection">
            <FaarmLogo className="AppLogoSection__logo" />
            <Button
                className="AppLogoSection__button"
                text={farm.name}
                startIcon="overview"
                onClick={() => {
                    navigate('/');
                }}
            />
        </div>
    );
}
